import {
  Container,
  Sprite,
  Graphics,
  Text
} from 'pixi.js';
import {
  TimelineTimestamp,
  PlayerControl
} from 'storyboard-renderer';

export class TimeIndicator extends Container{

  protected minPositionX: number;
  /**
   * pixelben hol van a jobb széle
   */
  protected maxPositionX: number;

  protected indicator: Container;
  protected timeText: Text;
  protected playerControl: PlayerControl;

  constructor(playerControl: PlayerControl, maxPositionX: number, minPositionX?:number){
    super();

    this.setPlayerControl(playerControl);

    this.minPositionX = minPositionX || 0;
    this.setMaxPositionX(maxPositionX);

    this.indicator = this.createIndicator();
    this.addChild(this.indicator);

    this.indicator.pivot.x = 36; //px
    this.indicator.pivot.y = 0;
  }

  moveTo(time: TimelineTimestamp){
    this.playerControl.seekTo(time);
    this.setIndicatorPositionFromTime(time);
  }

  public setPlayerControl(value: PlayerControl){
    this.playerControl = value;
  }
  public getPlayerControl():PlayerControl{
    return this.playerControl;
  }

  public setMaxPositionX(value:number){
    this.maxPositionX = value;
  }
  public getMaxPositionX():number{
    return this.maxPositionX;
  }

  public setMinPositionX(value:number){
    this.minPositionX = value;
  }
  public getMinPositionX():number{
    return this.minPositionX;
  }

  public getCurrentTime():TimelineTimestamp{
    return this.playerControl.getCurrentTime();
  }
  public getMaxTime():TimelineTimestamp{
    return this.playerControl.getMaxTime();
  }

  protected createIndicator():Container{
    let ret = new Container;

    let self = this;

    let top = this.createIndicatorTop();
    let body = this.createIndicatorBody();
    let text = this.createTimeText();
    this.timeText = text;

    top.addChild(text);

    top.interactive = true;
    top.buttonMode = true;
    top.on('pointerdown', function(event){
      event.stopPropagation();
      this._dragData = event.data;
    });
    top.on('pointermove', function(event){
      if (this._dragData){
        event.stopPropagation();
        /**
         * bár csak a "top"-ot lehet megfogni, a teljes "ret" containert fogjuk pozícionálni vele
         */
        let newPosition = this._dragData.getLocalPosition(ret.parent);
        let x = newPosition.x;
        if (x < self.minPositionX){
          x = self.minPositionX;
        }
        if (x > self.maxPositionX){
          x = self.maxPositionX;
        }
        ret.x = x;

        self.setCurrentTimeFromIndicatorPosition(ret.x);
      }
    });
    let pointerUp = function(event){
      if (this._dragData){
        event.stopPropagation();
        /**
         * triggereljük a playerControl-on is a moveTo-t ezzel
         */
        self.moveTo(self.playerControl.getCurrentTime());
      }
      this._dragData = null;
    };
    top.on('pointerupoutside', pointerUp);
    top.on('pointerup', pointerUp);

    ret.addChild(top);
    ret.addChild(body);
    return ret;
  }
  protected createIndicatorTop():Sprite{
    let ret = Sprite.fromImage('assets/images/timeline-indicator-top.png');

    return ret;
  }
  protected createIndicatorBody():Graphics{
    let ret = new Graphics();
    ret.beginFill(0xf73d3d);
    ret.drawRect(36, 25, 1, 200);
    return ret;
  }
  protected createTimeText():Text{
    let ret = new Text('00:00', {fontFamily : 'Arial', fontSize: 12, fill : 0xFFFFFF, align : 'center'});
    Object.assign(ret,
      {
        setFromTimestamp: function(value: TimelineTimestamp){

          this.text = value.asMinutesSecondsString();
        }
      }
    );
    ret.anchor.x = 0.5;
    ret.anchor.y = 0;
    ret.position.x = 36;
    ret.position.y = 5;
    return ret;
  }

  ticker(delta?){
    if (this.timeText){
      this.timeText['setFromTimestamp'](this.playerControl.getCurrentTime());
    }
    this.setIndicatorPositionFromTime(this.playerControl.getCurrentTime());
  }

  public getPosition(){
    return this.indicator.position;
  }

  protected setIndicatorPositionFromTime(value: TimelineTimestamp){

    let positionPercentage = value.percentageBetween(this.playerControl.getMinTime(), this.playerControl.getMaxTime());
    let maxDuration = this.playerControl.getMaxTime().sub(this.playerControl.getMinTime());
    let newPositionX = (this.maxPositionX - this.minPositionX) * positionPercentage;

    this.indicator.x = Math.floor(newPositionX);
  }
  public getTimeFromIndicatorPosition(positionX: number):TimelineTimestamp{

    let percentage = positionX / (this.maxPositionX - this.minPositionX);
    let maxDuration = this.playerControl.getMaxTime().sub(this.playerControl.getMinTime());
    return TimelineTimestamp.fromMilliseconds(maxDuration.as_milliseconds * percentage);
  }
  protected setCurrentTimeFromIndicatorPosition(positionX: number){

    let percentage = positionX / (this.maxPositionX - this.minPositionX);
    let maxDuration = this.playerControl.getMaxTime().sub(this.playerControl.getMinTime());
    this.playerControl.getCurrentTime().setMilliseconds(maxDuration.as_milliseconds * percentage);
  }
}



// WEBPACK FOOTER //
// ./src/app/storyboard/storyboard-edit/timeline/audio-track/waveform/waveform-renderer/time-indicator.ts